export const rootPaths = {
  root: '/',
  login: '/freelancer/auth/login',
  linkedinLogin: '/freelancer/auth/linkedIn/callback',
  register: '/freelancer/auth/register',
  forgotPassword: '/freelancer/auth/forgot-password',
  changePassword: '/freelancer/change-password',
  platformSettings: '/freelancer/platform-settings',
  onboarding: '/freelancer/auth/onboarding',
  otpVerify: '/freelancer/auth/otp-verify',
  resetPassword: '/freelancer/auth/reset-password',
  home: '/freelancer/home',
  tutorials: '/freelancer/tutorials',
  knowledgeHub: '/freelancer/knowledge-hub',
  knowledgeHubDetail: '/freelancer/knowledge-hub/:id',
  createProfile: '/freelancer/create-profile',
  viewProfile: '/freelancer/view-profile',
  profileDetails: '/freelancer/profile-details',
  /** Creator view of a freelancer (public profile, no personal details) */
  freelancerPublicProfile: '/freelancer/profile',
  creatorOnboarding: '/freelancer/creator-onboarding',
  creatorOnboardingApplication: '/freelancer/creator-onboarding/applications',
  creatorPackage: '/freelancer/create-package',
  packagePreview: '/freelancer/package-preview',
  packageDetails: '/freelancer/package-details',
  packageList: '/freelancer/package-list',
  packageCoupons: '/freelancer/package-coupons',
  browsePackages: '/freelancer/browse-packages',
  freelancerPackagePreview: '/freelancer/browse-packages/:packageId',
  myJoinRequests: '/freelancer/my-join-requests',
  editPackage: '/freelancer/packages/edit',
  teamInvitation: '/freelancer/team-invitation/:token',
  createGigs: '/freelancer/create-gigs',
  gigsPreview: '/freelancer/gigs-preview',
  gigsDetails: '/freelancer/gigs/details',
  gigsList: '/freelancer/gigs-list',
  experience: '/freelancer/experience',
};
